import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import axios from '../../../../_services/api/axios';
import withErrorHandler from '../../../../_hoc/withErrorHandler';
import * as actionCreators from '../../../../_store/actions/index';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import { GreyBox, Modal, Button, Flex, FlexColumn } from 'components'
import { fileDownload } from '../../../../_helpers/download.js';

class ExportJobModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPrinting : false
        }
	}
    componentWillUnmount = () => {
        this.props.onCalculatorJobExportFetchReset();
        if(this.state.isPrinting) this.props.onPrintingStart();
    }
    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if(!prevProps.state.export.fetched && this.props.state.export.fetched) {
            fileDownload(this.props.state.export.filebody, this.props.state.export.filename);
            this.props.onCalculatorJobExportFetchReset();
        }
    }

    onPrint = () => {
        this.setState(prevState => ({
            isPrinting: true
        }), () => {
            this.props.history.push('/jobs/' + this.props.state.job.details.Id); 
        });
    }

    onExport = (type) => {
        this.props.onCalculatorJobExportFetch(this.props.state.job.details.Id, type, this.props.currentLanguage);
    }

	render () {
        return (
            <Modal show={true}>
                <GreyBox outerMargin="true" title={this.props.translate('exportjobmodal.title')} titleTheme="light">
                    <Flex>
                        <FlexColumn col="100*47">
                            <Button multiline="true" type="button" value={this.props.translate('exportjobmodal.print.label')} nomargin="true" onClick={this.onPrint}/>
                        </FlexColumn>
                        <FlexColumn col="100*47">
                            <Button multiline="true" type="button" value={this.props.translate('exportjobmodal.xlsx.label')} nomargin="true" onClick={this.onExport.bind(this, 'excel')}/>
                        </FlexColumn>
                    </Flex>
                    <Button href={'/jobs/' + this.props.state.job.details.Id} theme="light" value={this.props.translate('exportjobmodal.secondary.label')} />
                </GreyBox>
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        defaults: state.defaults,
        state: state.calculatorJob,
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,
        printing: state.printing
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCalculatorJobExportFetch: (id,type,lang) => dispatch(actionCreators.calculatorJobExportFetch(id,type,lang)),
        onCalculatorJobExportFetchReset: () => dispatch(actionCreators.calculatorJobExportFetchReset()),
        onPrintingStart: () => dispatch(actionCreators.printingStart()),
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withErrorHandler(ExportJobModal, axios)));


// WEBPACK FOOTER //
// ./src/components/pages/JobPage/ExportJobModal/index.js